import React, { useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { TYPE } from '../../../theme'
import { AutoColumn } from '../../../components/Column'
import { RowBetween } from '../../../components/Row'
import Tag from 'components/Tag'

const InputPanel = styled.div`
  ${({ theme }) => theme.flexColumnNoWrap}
  position: relative;
  border-radius: 14px;
  background-color: ${({ theme }) => theme.bg2};
  z-index: 1;
  width: 100%;
`

const ContainerRow = styled.div<{ error: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 14px;
  border: 1px solid ${({ error, theme }) => (error ? theme.red1 : theme.bg2)};
  transition: border-color 300ms ${({ error }) => (error ? 'step-end' : 'step-start')},
    color 500ms ${({ error }) => (error ? 'step-end' : 'step-start')};
  background-color: ${({ theme }) => theme.bg2};
`

const InputContainer = styled.div`
  flex: 1;
  padding: 1rem;
`

const Input = styled.input<{ error?: boolean }>`
  font-size: 1.25rem;
  outline: none;
  border: none;
  flex: 1 1 auto;
  width: 0;
  background-color: ${({ theme }) => theme.bg2};
  transition: color 300ms ${({ error }) => (error ? 'step-end' : 'step-start')};
  color: ${({ error, theme }) => (error ? theme.red1 : 'white')};
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
  width: 100%;
  ::placeholder {
    color: ${({ theme }) => theme.text4};
  }
  padding: 0px;
  -webkit-appearance: textfield;

  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  ::placeholder {
    color: ${({ theme }) => theme.text4};
  }
`

export default function ReferralInputPanel({
  id,
  value,
  handleChange,
  disabled,
  error = false,
  isTestnetUser = false,
}: {
  id?: string
  // the typed string value
  value: string
  // triggers whenever the typed value changes
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  error: boolean
  disabled: boolean
  isTestnetUser: boolean
}) {
  const theme = useContext(ThemeContext)

  return (
    <InputPanel id={id}>
      <ContainerRow error={error}>
        <InputContainer>
          <AutoColumn gap="md">
            <RowBetween>
              <TYPE.black color={theme.text2} fontWeight={500} fontSize={14}>
                Username ID
              </TYPE.black>
            </RowBetween>
            <Input
              className="referral-address-input"
              type="text"
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="off"
              maxLength={18}
              spellCheck="false"
              placeholder="HyperswapUser"
              error={error}
              onChange={handleChange}
              value={value}
              disabled={disabled}
            />
            <div style={{ display: 'flex', gap: '4px' }}>
              {isTestnetUser && (
                <>
                  <Tag variant={2}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="icon icon-tabler icons-tabler-outline icon-tabler-progress-check"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M10 20.777a8.942 8.942 0 0 1 -2.48 -.969" />
                      <path d="M14 3.223a9.003 9.003 0 0 1 0 17.554" />
                      <path d="M4.579 17.093a8.961 8.961 0 0 1 -1.227 -2.592" />
                      <path d="M3.124 10.5c.16 -.95 .468 -1.85 .9 -2.675l.169 -.305" />
                      <path d="M6.907 4.579a8.954 8.954 0 0 1 3.093 -1.356" />
                      <path d="M9 12l2 2l4 -4" />
                    </svg>
                    Testnet User
                  </Tag>
                </>
              )}
            </div>
          </AutoColumn>
        </InputContainer>
      </ContainerRow>
    </InputPanel>
  )
}
